import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Permission } from '../../model/permission';
import { StorageService } from '../managers/storage.service';
import { Config } from './config';


@Injectable({
  providedIn: 'root'
})
export class PermissionService extends Config{

  private permissions: Observable<Permission[]>;

  constructor(private httpClient: HttpClient, private storageService: StorageService) {
    super();
  }

  public storePermission(permission: Permission): Observable<any> {
    var url = "permission_store";

    return this.httpClient.post(this.BASE_URL + url, permission, this.storageService.getHeaders());
  }

  public getPermissionsWithKeyword(maxNumberOfItems: number, pageNumber: number, keyword: string): any {
    let url: string;

    url = "permission_get_all?" + ("maxItemPerPage=" + maxNumberOfItems) + "&" + ("page=" + pageNumber) + "&"
      + ("keyword=" + keyword);

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

  public getPermissions(maxNumberOfItems: number, pageNumber: number): any {
    let url: string;

    url = "permission_get_all?" + ("maxItemPerPage=" + maxNumberOfItems) + "&" + ("page=" + pageNumber)

    return this.httpClient.get(this.BASE_URL + url, this.storageService.getHeaders());
  }

  public getPermissionsByID(obj: any) {
    let url: string;

    url = "permission_get_all_by_id";

    return this.httpClient.post(this.BASE_URL + url, obj, this.storageService.getHeaders());
  }

  public getPermissionsByUserID(userID: number){
    let url = "permissions_get_all_by_userID";

    return this.httpClient.post(this.BASE_URL + url, {"userID": userID}, this.storageService.getHeaders());
  }

}
